import { flexRender } from "@tanstack/react-table"
import cn from "@/v2-ui/utils/utils.cn"
import { useTableContext } from "./table.context"
import { SPACER_COLUMN_ID } from "./table.constants"
import { getColumnSizeStyle } from "./table.utils"
import TableSkeletonRows from "./TableSkeletonRows"

const SKELETON_ROW_COUNT = 12

/**
 * The table before its first rows: the real header over a body of
 * placeholder rows, laid out exactly as the loaded table will be so nothing
 * shifts when the data lands.
 */
function TableSkeleton() {
  const { table, hasPersistence } = useTableContext()
  const groups = table.getHeaderGroups()
  const columnSizing = table.getState().columnSizing

  return (
    <div className="ui-table-content">
      <table
        className={cn("ui-table-content-table", {
          "ui-table-content-table-is-resizable": hasPersistence,
        })}
      >
        <thead className="ui-table-header">
          {groups.map((group) => (
            <tr key={group.id}>
              {group.headers.map((header) => {
                if (header.column.id === SPACER_COLUMN_ID) {
                  return <th key={header.id} className="ui-table-spacer-cell" />
                }
                return (
                  <th
                    key={header.id}
                    className="ui-table-header-cell"
                    style={getColumnSizeStyle({
                      column: header.column,
                      columnSizing,
                      hasPersistence,
                    })}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>

        <tbody className="ui-table-body">
          <TableSkeletonRows rowCount={SKELETON_ROW_COUNT} />
        </tbody>
      </table>
    </div>
  )
}

export default TableSkeleton
